import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Language } from './language';
export const activeLanguageKey = 'activeLanguageName';
@Component({
    selector: 'app-change-language',
    templateUrl: './change-language.component.html',
    styleUrls: ['./change-language.component.scss'],
    standalone: false
})
export class ChangeLanguageComponent implements OnInit {

  public languages: Language[] = [];
  constructor(private translateService: TranslateService) {
  }

  ngOnInit(): void {
    this.createLanguagesWithActive();

  }
  createLanguagesWithActive() {
    const langName = localStorage.getItem(activeLanguageKey)
    this.languages = [
      {
        name: 'pl',
      },
      {
        name: 'en'
      },
      {
        name: 'hu'
      }
    ];
    this.setAllLanguagesInActive() ;
    const index = this.languages.findIndex(lang => lang.name == langName);
    if (index == -1) {
      console.log(`There is no language with name:${langName}. Setting default language.`);
      this.languages[0].active = true;
      this.translateService.use(this.languages[0].name);
      return;
    }
    this.languages[index].active = true;
    this.translateService.use(this.languages[index].name);
  }
  changeLanguage(language: Language) {
    const index = this.languages.findIndex(l => l.name == language.name);
    if (index == -1) {
      console.log(`There is no language with name:${language.name}. Setting default language.`);
    }
    this.setAllLanguagesInActive();
    localStorage.setItem(activeLanguageKey, language.name);
    this.languages[index].active = true;
    this.translateService.use(this.languages[index].name);
  }
  setAllLanguagesInActive() {
    for (let index = 0; index < this.languages.length; index++) {
      this.languages[index].active = false;
    }
  }

}
